
export const ID = "Id";
export const Title = "title";
export const Recruiter = "recruiter";
export const Jobseeker = "jobseeker";
export const RedirectUrl = "redirect";
export const CandidateId = "candidateId";
export const CreditManagementTab = "creditManagement";
export const Keywords = "keywords";
export const RegionId = "regionId";
export const CountyId = "countyId";
export const Jobs = "-jobs";
export const CVS = "-cvs";
export const ByKeyword = "by-keyword-";
export const JobsIn ="-jobs-in-";
export const CVsIn ="-cvs-in-";
export const SearchInIndustry = "industry";
export const SearchInSimple = "simple";
export const SearchInLocation = "location";
export const SearchyByRegion = "locations";
export const JobId = "JobId";
export const ApplicationUrl ="ApplicationUrl";
export const JobSourceId  = "JobSourceId";
export const ApplyNow = "applynow"; 

